export default "__VITE_ASSET__ebb2cc6d__"